import type { ProductKey } from "../types/entitlements";

export type ProductCatalogueEntry = {
  key: ProductKey;
  name: string;
  tagline: string;
  path?: string; // relative path on the current host where the product opens; undefined until it launches
  brandColour: string;
  logo: string;
  requiresOrgAdmin?: boolean;
  // Listed for its branding but not sold or shown anywhere yet — hidden for everyone
  // until the product launches.
  notYetOffered?: boolean;
  // The role an admin gives by default when a member asks for access to this product.
  defaultRequestRole?: string;
};

export const productCatalogue: ProductCatalogueEntry[] = [
  {
    key: "foundry-flow",
    name: "Foundry Flow",
    tagline: "Application packaging & conversion workflows.",
    path: "/foundry",
    logo: "/logo-foundry_flow.png",
    brandColour: "#F97316",
    defaultRequestRole: "foundry-flow-editor",
  },
  {
    key: "guardian",
    name: "Guardian",
    tagline: "Security policy management & compliance drift detection.",
    path: "/guardian",
    logo: "/logo-guardian.png",
    brandColour: "#1FC774",
    defaultRequestRole: "guardian-analyst",
  },
  {
    key: "foundry-studio",
    name: "Foundry Studio",
    tagline: "Package setup, workflow configuration & task management.",
    logo: "/logo-foundry_studio.png",
    brandColour: "#2563EB",
    notYetOffered: true, // EIT-70 launches Studio and removes this
  },
];
